import apiClient from '../services/api/config';

/**
 * Resolve a stored asset URL to one the browser can fetch.
 *
 * R2-backed assets are persisted as relative paths (e.g. "/r2/pulse/abc.png").
 * The R2 route is served by the API worker, not the frontend origin, so a
 * raw <img src="/r2/..."> on pages.dev 404s. Prefix with the API base.
 *
 * Pass-through for empty values, absolute URLs, and data: URIs.
 */
export function resolveAssetUrl(url?: string | null): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;
  if (url.startsWith('/r2/')) {
    const base = apiClient.defaults.baseURL || '';
    return `${base}${url}`;
  }
  return url;
}
